import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", { id: "images-1, photos, pictures, shot" }, [
      _createElementVNode("path", {
        id: "vector",
        d: "M2.3335 9.47223L4.34862 8.05331C4.92696 7.69043 5.6996 7.77606 6.17257 8.25545C7.22972 9.32694 8.45532 10.3011 10.1252 10.3011C11.6641 10.3011 12.684 9.76422 13.6668 8.8392M3.00016 13.6654H13.0002C13.3684 13.6654 13.6668 13.3669 13.6668 12.9987V2.9987C13.6668 2.63051 13.3684 2.33203 13.0002 2.33203H3.00016C2.63197 2.33203 2.3335 2.63051 2.3335 2.9987V12.9987C2.3335 13.3669 2.63197 13.6654 3.00016 13.6654ZM11.6668 5.9987C11.6668 6.91917 10.9206 7.66536 10.0002 7.66536C9.07969 7.66536 8.3335 6.91917 8.3335 5.9987C8.3335 5.07822 9.07969 4.33203 10.0002 4.33203C10.9206 4.33203 11.6668 5.07822 11.6668 5.9987Z",
        stroke: "#7F7F83"
      })
    ], -1)
  ])))
}
export default { render: render }